import { render } from "./template.vue?vue&type=template&id=1fe8bf1c&scoped=true&lang=pug"
const script = {}

import "./template.vue?vue&type=style&index=0&id=1fe8bf1c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe8bf1c"]])

export default __exports__